// import React, { useEffect, useState } from 'react';
// import usePersonalOrdersByCustomerId from '../../hooks/usepersonalOrderByCustomerID';
// import useItems from '../../hooks/useItems';
// import { parseISO, startOfWeek, differenceInCalendarWeeks, isAfter } from 'date-fns';
// import Loader from '../common/GlobalLoader'; 
// const customerId = localStorage.getItem('user')
//   ? JSON.parse(localStorage.getItem('user')).CustomerID
//   : null;

// const DashboardView = () => {
//   const {
//     salesOrders,
//     loading: ordersLoading,
//     error: ordersError
//   } = usePersonalOrdersByCustomerId(customerId);

//   const { items, loading: itemsLoading, error: itemsError } = useItems(5);

//   const [weeklyOrderCounts, setWeeklyOrderCounts] = useState([0, 0, 0, 0, 0, 0]);

//   useEffect(() => {
//     if (!salesOrders || salesOrders.length === 0) {
//       setWeeklyOrderCounts([0, 0, 0, 0, 0, 0]);
//       return;
//     }

//     const now = new Date();
//     const sixWeeksAgo = startOfWeek(new Date(now.setDate(now.getDate() - 7 * 5)));

//     const counts = [0, 0, 0, 0, 0, 0];

//     salesOrders.forEach(order => {
//       let orderDate;
//       try {
//         orderDate = parseISO(order.date);
//       } catch (e) {
//         return;
//       }
//       if (isAfter(orderDate, sixWeeksAgo)) {
//         const weekIndex = differenceInCalendarWeeks(new Date(), orderDate);
//         if (weekIndex >= 0 && weekIndex < 6) {
//           counts[5 - weekIndex] += 1;
//         }
//       }
//     });

//     setWeeklyOrderCounts(counts);
//   }, [salesOrders]);

//   const totalOrders = weeklyOrderCounts.reduce((sum, val) => sum + val, 0);
//   const hasOrders = weeklyOrderCounts.some(count => count > 0);
//   const maxOrder = hasOrders ? Math.max(...weeklyOrderCounts) : 1;
//   const maxBarHeight = 160;

//   // Safe extraction for items
//   let itemsArray = [];

//   if (Array.isArray(items)) {
//     itemsArray = items;
//   } else if (items && typeof items === 'object') {
//     if (Array.isArray(items.items)) {
//       itemsArray = items.items;
//     } else if (Array.isArray(items.data)) {
//       itemsArray = items.data;
//     }
//   }

//   const newArrivals = itemsArray.length > 0
//     ? itemsArray
//         .slice()
//         .sort((a, b) => {
//           const aDate = new Date(a.createdAt || a.date || a.created_date || a.created);
//           const bDate = new Date(b.createdAt || b.date || b.created_date || b.created);
//           return bDate - aDate;
//         })
//         .slice(0, 5)
//     : [];

//   const isLoading = ordersLoading || itemsLoading;

//   return (
//     <div className="relative">
//       {/* ✅ Global loader overlay */}
//       {isLoading && (
//         <div className="absolute inset-0 z-50 bg-white/70 flex items-center justify-center">
//           <Loader />
//         </div>
//       )}

//       <div className={`bg-white border rounded-xl p-8 max-w-6xl mx-auto shadow-md ${isLoading ? 'opacity-30 pointer-events-none select-none' : ''}`}>
//         <h2 className="text-2xl font-semibold text-gray-900 mb-8">Dashboard Overview</h2>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {/* Total Orders Card */}
//           <div className="bg-gray-50 rounded-lg p-8 shadow-sm flex flex-col items-center justify-center">
//             <h3 className="text-xl font-medium text-gray-800 mb-3">Total Orders</h3>
//             <p className="text-5xl font-extrabold text-[#33080F]">
//               {totalOrders}
//             </p>
//           </div>

//           {/* Orders Over Last 6 Weeks Card */}
//           <div className="bg-gray-50 rounded-lg p-8 shadow-sm">
//             <h3 className="text-xl font-medium text-gray-800 mb-6">Orders in the Last 6 Weeks</h3>

//             {!hasOrders ? (
//               <div className="h-40 flex items-center justify-center text-gray-500 italic">
//                 No orders in the past 6 weeks.
//               </div>
//             ) : (
//               <div className="flex items-end space-x-6 h-40">
//                 {weeklyOrderCounts.map((count, idx) => {
//                   const barHeight = (count / maxOrder) * maxBarHeight;
//                   return (
//                     <div
//                       key={idx}
//                       className="flex flex-col items-center"
//                       role="listitem"
//                       aria-label={`Week ${idx + 1} orders: ${count}`}
//                     >
//                       <div
//                         className="w-10 bg-[#33080F] rounded-t-lg shadow-md transition-all duration-300 hover:bg-[#5c180c]"
//                         style={{ height: `${barHeight}px` }}
//                         title={`Week ${idx + 1}: ${count} orders`}
//                       />
//                       <span className="mt-2 text-sm font-semibold text-gray-700 select-none">
//                         W{idx + 1}
//                       </span>
//                     </div>
//                   );
//                 })}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* New Arrivals */}
//         <div className="mt-12">
//           <h3 className="text-xl font-medium text-gray-800 mb-6">New Items</h3>
//           <ul className="divide-y divide-gray-200 bg-gray-50 rounded-lg shadow-sm">
//             {newArrivals.length > 0 ? (
//               newArrivals.map(item => (
//                 <li
//                   key={item.id || item._id}
//                   className="flex justify-between items-center p-5 hover:bg-gray-100 transition cursor-default"
//                 >
//                   <div>
//                     <p className="text-base font-medium text-gray-900">
//                       {item.name || item.title || item.productName}
//                     </p>
//                     <p className="text-sm text-gray-500">
//                       Added on {item.date || item.createdAt || item.created_date || item.cf_last_stock_check}
//                     </p>
//                   </div>
//                   <span className="text-xs px-3 py-1 bg-[#5c180c] text-white rounded-full font-semibold select-none">
//                     New
//                   </span>
//                 </li>
//               ))
//             ) : (
//               <li className="p-5 text-gray-500 italic text-center">No new items available.</li>
//             )}
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DashboardView;
import React, { useEffect, useState } from 'react';
import usePersonalOrdersByCustomerId from '../../hooks/usepersonalOrderByCustomerID';
import useDashboardItems from '../../hooks/useDashboardItems';   // <-- UPDATED
import { parseISO, startOfWeek, differenceInCalendarWeeks, isAfter } from 'date-fns';
import Loader from '../common/GlobalLoader'; 

const customerId = localStorage.getItem('user')
  ? JSON.parse(localStorage.getItem('user')).CustomerID
  : null;

const DashboardView = () => {
  const {
    salesOrders,
    loading: ordersLoading,
    error: ordersError
  } = usePersonalOrdersByCustomerId(customerId);

  // ⬇️ UPDATED: useDashboardItems instead of useItems(5)
  const { items, loading: itemsLoading, error: itemsError } = useDashboardItems();

  const [weeklyOrderCounts, setWeeklyOrderCounts] = useState([0, 0, 0, 0, 0, 0]);

  useEffect(() => {
    if (!salesOrders || salesOrders.length === 0) {
      setWeeklyOrderCounts([0, 0, 0, 0, 0, 0]);
      return;
    }

    const now = new Date();
    const sixWeeksAgo = startOfWeek(new Date(now.setDate(now.getDate() - 7 * 5)));

    const counts = [0, 0, 0, 0, 0, 0];

    salesOrders.forEach(order => {
      let orderDate;
      try {
        orderDate = parseISO(order.date);
      } catch (e) {
        return;
      }
      if (isAfter(orderDate, sixWeeksAgo)) {
        const weekIndex = differenceInCalendarWeeks(new Date(), orderDate);
        if (weekIndex >= 0 && weekIndex < 6) {
          counts[5 - weekIndex] += 1;
        }
      }
    });

    setWeeklyOrderCounts(counts);
  }, [salesOrders]);

  const totalOrders = weeklyOrderCounts.reduce((sum, val) => sum + val, 0);
  const hasOrders = weeklyOrderCounts.some(count => count > 0);
  const maxOrder = hasOrders ? Math.max(...weeklyOrderCounts) : 1;
  const maxBarHeight = 160;

  // Safe extraction for items
  let itemsArray = [];

  if (Array.isArray(items)) {
    itemsArray = items;
  } else if (items && typeof items === 'object') {
    if (Array.isArray(items.items)) {
      itemsArray = items.items;
    } else if (Array.isArray(items.data)) {
      itemsArray = items.data;
    }
  }

  const newArrivals = itemsArray.length > 0
    ? itemsArray
        .slice()
        .sort((a, b) => {
          const aDate = new Date(a.createdAt || a.date || a.created_date || a.created);
          const bDate = new Date(b.createdAt || b.date || b.created_date || b.created);
          return bDate - aDate;
        })
        .slice(0, 5)
    : [];

  const isLoading = ordersLoading || itemsLoading;

  return (
    <div className="relative">
      {/* ✅ Global loader overlay */}
      {isLoading && (
        <div className="absolute inset-0 z-50 bg-white/70 flex items-center justify-center">
          <Loader />
        </div>
      )}

      <div className={`bg-white border rounded-xl p-4 sm:p-6 md:p-8 max-w-6xl mx-auto shadow-md ${isLoading ? 'opacity-30 pointer-events-none select-none' : ''}`}>
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-6 sm:mb-8">Dashboard Overview</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8">
          {/* Total Orders Card */}
          <div className="bg-gray-50 rounded-lg p-5 sm:p-8 shadow-sm flex flex-col items-center justify-center">
            <h3 className="text-lg sm:text-xl font-medium text-gray-800 mb-3 text-center">Total Orders</h3>
            <p className="text-4xl sm:text-5xl font-extrabold text-[#33080F]">
              {totalOrders}
            </p>
          </div>

          {/* Orders Over Last 6 Weeks Card */}
          <div className="bg-gray-50 rounded-lg p-5 sm:p-8 shadow-sm min-w-0">
            <h3 className="text-lg sm:text-xl font-medium text-gray-800 mb-4 sm:mb-6">Orders in the Last 6 Weeks</h3>

            {!hasOrders ? (
              <div className="h-36 sm:h-40 flex items-center justify-center text-gray-500 italic text-sm sm:text-base px-2 text-center">
                No orders in the past 6 weeks.
              </div>
            ) : (
              <div className="overflow-x-auto -mx-1 px-1 pb-1">
                <div className="flex items-end justify-between gap-2 sm:gap-4 min-w-[260px] h-36 sm:h-40">
                {weeklyOrderCounts.map((count, idx) => {
                  const barHeight = (count / maxOrder) * maxBarHeight;
                  return (
                    <div
                      key={idx}
                      className="flex flex-col items-center flex-1 min-w-0 max-w-[3.5rem]"
                      role="listitem"
                      aria-label={`Week ${idx + 1} orders: ${count}`}
                    >
                      <div
                        className="w-full max-w-[2rem] sm:w-10 sm:max-w-none mx-auto bg-[#33080F] rounded-t-lg shadow-md transition-all duration-300 hover:bg-[#5c180c]"
                        style={{ height: `${barHeight}px` }}
                        title={`Week ${idx + 1}: ${count} orders`}
                      />
                      <span className="mt-2 text-xs sm:text-sm font-semibold text-gray-700 select-none">
                        W{idx + 1}
                      </span>
                    </div>
                  );
                })}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* New Arrivals */}
        <div className="mt-8 sm:mt-12">
          <h3 className="text-lg sm:text-xl font-medium text-gray-800 mb-4 sm:mb-6">New Items</h3>
          <ul className="divide-y divide-gray-200 bg-gray-50 rounded-lg shadow-sm">
            {newArrivals.length > 0 ? (
              newArrivals.map(item => (
                <li
                  key={item.id || item._id}
                  className="flex flex-col gap-3 sm:flex-row sm:justify-between sm:items-center p-4 sm:p-5 hover:bg-gray-100 transition cursor-default"
                >
                  <div className="min-w-0">
                    <p className="text-sm sm:text-base font-medium text-gray-900 break-words">
                      {item.name || item.title || item.productName}
                    </p>
                    <p className="text-xs sm:text-sm text-gray-500 break-words mt-1">
                      Added on {item.date || item.createdAt || item.created_date || item.cf_last_stock_check}
                    </p>
                  </div>
                  <span className="text-xs px-3 py-1 bg-[#5c180c] text-white rounded-full font-semibold select-none shrink-0 self-start sm:self-center">
                    New
                  </span>
                </li>
              ))
            ) : (
              <li className="p-4 sm:p-5 text-gray-500 italic text-center text-sm">No new items available.</li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DashboardView;
